import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
console.log(process.env);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/editor/:id/detail/",
      name: "detail",
      component: () =>
        import(/* webpackChunkName: "detail" */ "./views/App/Detail.vue"),
      meta: { hasNav: false }
    },
    {
      path: "/editor/:id/preview-only/",
      name: "preview-only-exact",
      component: () =>
        import(/* webpackChunkName: "detail" */ "./views/App/PreviewOnly.vue"),
      meta: { hasNav: false, exact: true }
    },
    {
      path: "/editor/:id/preview-only/fill/",
      name: "preview-only-fill",
      component: () =>
        import(/* webpackChunkName: "detail" */ "./views/App/PreviewOnly.vue"),
      meta: { hasNav: false, fill: true }
    },
    {
      path: "/editor/:id/preview-only/fill/:ms_per_image",
      name: "preview-only-fill-image-seconds",
      component: () =>
        import(/* webpackChunkName: "detail" */ "./views/App/PreviewOnly.vue"),
      meta: { hasNav: false, fill: true }
    },
    {
      path:
        "/editor/:id/preview-only/fill/:ms_per_image/:transition_type_slug/:transition_ms",
      name: "preview-only-fill-image-seconds-with-transition",
      component: () =>
        import(/* webpackChunkName: "detail" */ "./views/App/PreviewOnly.vue"),
      meta: { hasNav: false, fill: true }
    },
    {
      path: "/editor/:id/",
      name: "edit",
      component: () =>
        import(/* webpackChunkName: "detail" */ "./views/App/Detail.vue"),
      meta: { hasNav: false }
    },
    {
      path: "/dev/",
      name: "dev-shows",
      component: () =>
        import(/* webpackChunkName: "detail" */ "./views/App/DevShows.vue"),
      meta: { hasNav: false }
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    },
    {
      path: "/account",
      name: "account",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/App/Account.vue")
    },
    {
      path: "/",
      name: "root",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/App/Account.vue")
    }
  ]
});
